

import "./Header.css";
import { Link } from "react-router-dom";
import React, { useState } from "react";


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  React.useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [menuOpen]);

  return (
    <header className="header">
      <div className="header__container">
        <Link to="/" className="header__left header__logo-link">Bengaluru Builds</Link>
        <nav className="header__nav desktop-nav">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/choose-your-template">Templates</Link>
        </nav>
        <button
          className="header__menu-btn"
          aria-label="Open menu"
          onClick={() => setMenuOpen(true)}
        >
          <span className="header__menu-icon" />
        </button>
        <div className={`header__mobile-menu${menuOpen ? " open" : ""}`}>
          <button
            className="header__close-btn"
            aria-label="Close menu"
            onClick={() => setMenuOpen(false)}
          >
            <span className="header__close-icon" />
          </button>
          <nav className="header__mobile-nav">
            <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
            <Link to="/pricing" onClick={() => setMenuOpen(false)}>Pricing</Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
            <Link to="/choose-your-template" onClick={() => setMenuOpen(false)}>Templates</Link>
          </nav>
        </div>
        {menuOpen && <div className="header__backdrop" onClick={() => setMenuOpen(false)} />}
      </div>
    </header>
  );
};

export default Header;
